import React, { memo, useCallback, useEffect, useState } from 'react';
import { Card } from 'components/ui/card';
import { Button } from 'components/ui/button';
import { cn } from 'lib/utils';
import { TenderCategory, TenderCategoryNames } from '@app/models';
import { useUserContext } from '@app/providers';
import Panel1Img from 'common/WelcomeBanner/1.png';
import Panel2Img from 'common/WelcomeBanner/2.png';
import Panel3Img from 'common/WelcomeBanner/3.png';
import Panel4Img from 'common/WelcomeBanner/4.png';

interface Props {
  defaultExpanded: boolean;
  value: TenderCategory | null;
  onSubmit: (tenderCategory: TenderCategory, isSubmit: boolean) => void;
}

function TenderCategoryForm(props: Props) {
  const { user } = useUserContext();
  const { defaultExpanded, value, onSubmit } = props;
  const [expanded, setExpanded] = useState<boolean>(defaultExpanded);
  const [checkedItem, setCheckedItem] = useState<number>(value ?? 0);

  useEffect(() => {
    if (value !== null && value !== undefined) {
      setCheckedItem(value);
    }
  }, [value]);

  const onChange = (tenderCategory: TenderCategory) => () => {
    setCheckedItem(tenderCategory);
    onSubmit(tenderCategory, false);
  };

  const onSubmitForm = useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      e.stopPropagation();
      setExpanded(false);
      onSubmit(value as TenderCategory, true);
    },
    [onSubmit, value]
  );

  return (
    <form onSubmit={onSubmitForm}>
      <Card className="p-6 mb-4">
        <h2 className="text-xl font-semibold mb-2">
          Выберите категорию объявления
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 justify-items-center">
          {[
            { category: TenderCategory.CONTRACTOR, img: Panel1Img },
            { category: TenderCategory.SUPPLIER, img: Panel2Img },
            { category: TenderCategory.VEHICLE, img: Panel3Img },
            { category: TenderCategory.WORKER, img: Panel4Img },
          ].map(({ category, img }) => (
            <Card
              key={category}
              className={cn(
                'flex flex-col items-center justify-between p-4 w-48 h-43 rounded-xl cursor-pointer transition border-2',
                checkedItem === category
                  ? 'border-primary shadow-lg'
                  : 'border-muted hover:border-primary/60 hover:shadow',
                'bg-muted/40'
              )}
              onClick={onChange(category)}
            >
              <div className="text-base font-semibold mb-2 text-center w-full">
                {TenderCategoryNames[category]}
              </div>
              <div className="flex-1 flex items-center justify-center w-full">
                <div className="w-28 h-28 flex items-center justify-center">
                  <img
                    src={img}
                    alt={TenderCategoryNames[category]}
                    className="max-w-full max-h-full object-contain block"
                  />
                </div>
              </div>
            </Card>
          ))}
        </div>
        <div className="flex justify-end mt-6">
          <Button type="submit" disabled={!checkedItem}>
            Далее
          </Button>
        </div>
      </Card>
    </form>
  );
}

export default memo(TenderCategoryForm);
